type SqlExecutor = {
  query: (
    sql: string,
    values?: unknown[],
  ) => Promise<{ rows: Array<Record<string, unknown>>; rowCount?: number | null }>;
};

export const CLAMP_QC_WORK_ORDER_QUANTITY_CAP_ERROR =
  "This work order’s planned quantity is already fully recorded in hub inspection (pass or fail). You cannot scan another serial for this build order without increasing quantity in Megaventory.";

export const CLAMP_QC_WORK_ORDER_QUANTITY_CAP_CODE = "clamp_qc_work_order_quantity_cap";

/** Same definition as the hub work-order list Complete column (`sgs_qc_at` set, pass or fail). */
export async function queryClampQcHubCompleteCount(
  executor: SqlExecutor,
  buildOrderId: number,
): Promise<number> {
  const result = await executor.query(
    `select count(*)::int as count
       from quality.clamp
      where quality.clamp.sgs_qc_work_order_id = $1::int
        and quality.clamp.sgs_qc_at is not null`,
    [buildOrderId],
  );
  const count = result.rows[0]?.["count"];
  return Math.max(0, Math.trunc(typeof count === "number" ? count : Number(count ?? 0)));
}

export async function queryClampSerialAlreadyRecordedOnWorkOrder(
  executor: SqlExecutor,
  serialText: string,
  buildOrderId: number,
): Promise<boolean> {
  const result = await executor.query(
    `select 1 as one
       from quality.clamp
      where quality.clamp.serial = $1::text
        and quality.clamp.sgs_qc_work_order_id = $2::int
        and quality.clamp.sgs_qc_at is not null
      limit 1`,
    [serialText, buildOrderId],
  );
  return (result.rowCount ?? 0) > 0;
}

export function clampQcWorkOrderQuantityCapExceeded(input: {
  plannedQuantity: number;
  currentCompleteCount: number;
  serialAlreadyRecordedOnThisWorkOrder: boolean;
}): boolean {
  if (input.serialAlreadyRecordedOnThisWorkOrder) {
    return false;
  }
  const planned = Math.max(0, Math.trunc(input.plannedQuantity));
  if (planned <= 0) {
    return false;
  }
  return input.currentCompleteCount >= planned;
}
